import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedTrainingAndPerformance = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title={`Add Training & Performance`}
    okText={`ADD TRAINING & PERFORMANCE`}
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label={`Choose a Training & Performance:`}
      queryVariables={{ typeId: FILTER_TYPE.TRAINING_AND_PERFORMANCE.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Training & Performanc is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedTrainingAndPerformance.Item = Item;

export default RelatedTrainingAndPerformance;
